module.exports = __webpack_public_path__ + "static/media/noodles.044a97da.png";